import { AlertTriangle, XCircle } from 'lucide-react';

import type { MigrationIssue } from '@/services/migration.service';
import cn from '@/utils/cn';

interface MigrationIssueListProps {
  issues: MigrationIssue[];
}

// Errors first: they are the reason a client was skipped.
export const MigrationIssueList = ({ issues }: MigrationIssueListProps) => {
  if (issues.length === 0) return <span className="text-xs text-muted-foreground">-</span>;
  const rank = (i: MigrationIssue): number => (i.level === 'error' ? 0 : 1);
  const sorted = [...issues].sort((a, b) => rank(a) - rank(b));
  return (
    <ul className="space-y-1">
      {sorted.map((i) => (
        <li
          key={`${i.level}-${i.sheet}-${i.sheetRow ?? 'x'}-${i.message}`}
          className={cn(
            'flex items-start gap-1.5 text-xs leading-snug',
            i.level === 'error' ? 'text-destructive' : 'text-foreground',
          )}
        >
          {i.level === 'error' ? (
            <XCircle className="mt-0.5 h-3.5 w-3.5 shrink-0" />
          ) : (
            <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0 text-warning" />
          )}
          <span>
            <span className="font-semibold text-muted-foreground">
              {i.sheetRow != null ? `${i.sheet} r${i.sheetRow}: ` : `${i.sheet}: `}
            </span>
            {i.message}
          </span>
        </li>
      ))}
    </ul>
  );
};
